module.exports = __webpack_public_path__ + "static/img/nav2.42906efe.png";